import comRichtext from '@/components/com-richtext.vue';
export default{
    name:'CompanyDetail',
    data(){
        return{
            detail:{},
            cType:[],
        }
    },
    created(){
        this.getData();
    },
    components:{
        comRichtext,
    },
    methods:{
        getData(){
            var body={
                id:this.$route.query.id,
            };
            this.get(this.api.getTldCompanyDetail,body).then(res=>{
                if(res.result==200){
                    this.detail=res.data;
                    this.getCompanyType();
                }
            }).catch();
        },
        getCompanyType(){
            this.get(this.api.getCompanytype).then(res=>{
                if(res.result==200){
                    this.cType=res.data;
                    for(var i =0; i <this.cType.length;i++){
                        if(this.detail.companytype == this.cType[i].code){
                            this.detail.companytype=this.cType[i].name;
                            break;
                        }
                            
                    }
                    
                }
            }
            ).catch();
        }
        
        
    }
}